import { useParams } from 'react-router-dom';
import ArticleLogInGate from './ArticleLogInGate.js';
import BottomBar from './BottomBar.js';
import BottomBarProTargeting from './BottomBarProTargeting.campaign.js';
import BottomBarProRSSFeed from './BottomBarProRSSFeed.campaign.js';
import BottomBarExpandable from './BottomBarExpandable.campaign.js';
import Overlay from './Overlay.js';
import OverlayHomeStretch from './OverlayHomeStretch.campaign.js';
import OverlayApplicationPro from './OverlayApplicationPro.campaign.js';
import OverlayMadMoneyCramer from './OverlayMadMoneyCramer.campaign.js';
import OverlayCramerInvestingGuide from './OverlayCramerInvestingGuide.campaign.js';
import OverlayApplicationProRss from './OverlayApplicationProRss.campaign.js';
import Inline from './Inline.js';
import InlineWarrenBuffet from './InlineWarrenBuffet.campaign.js';
import OverlayProPersonalFinance from './OverlayProPersonalFinance.campaign.js';
import OverlayProNews from './OverlayProNews.campaign.js';
import ComponentResizer from './ComponentResizer.js';

function ComponentPage() {
  const { componentName } = useParams();

  const Component = {
    BottomBar,
    BottomBarProTargeting,
    BottomBarProRSSFeed,
    BottomBarExpandable,
    Overlay,
    OverlayHomeStretch,
    OverlayApplicationPro,
    OverlayMadMoneyCramer,
    OverlayCramerInvestingGuide,
    OverlayApplicationProRss,
    Inline,
    InlineWarrenBuffet,
    OverlayProPersonalFinance,
    OverlayProNews,
    ArticleLogInGate,
  }[componentName];

  if (!Component) {
    return <>Error: /components/{componentName} does not exist</>;
  }

  return (
    <>
      <ComponentResizer />
      <Component />
    </>
  );
}

export default ComponentPage;
